import type {
  TChangeEmailParams,
  TGetInitialDataResponse,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {mkPlayerEmail} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import globalDataMock from '~/api/endpoints/GetInitialData/mock'

export type TChangeEmailResponse = TGetInitialDataResponse

const endpoint = endpoints.account.changeEmail

export default class ChangeEmail extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(params: TChangeEmailParams): TChangeEmailResponse {
    return {
      authenticatedPlayerDetails: {
        ...globalDataMock.authenticatedPlayerDetails,
        email: mkPlayerEmail(params.email),
      },
    }
  }

  protected transformResponse(r: TChangeEmailResponse) {
    return r
  }
}
